import React from 'react';

const contador = props => {
    return (
        <div className="indicador"> 
        {
            props.tipo === 'normal' ?
            <div className={props.clase}>
                <p>{props.valor}</p>
                <h4><span className="dot"></span>{props.texto}</h4>
            </div> :
            <div>
                <p className={props.clase}>{props.valor}</p>
                <h5>{props.texto}</h5>
            </div>
        }
        </div>
    )
};

export default contador;